// src/ManageSpecialties.js - AGGIORNATO

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { SpecialtyModal } from './SpecialtyModal'; // Importa il nuovo modale
import { useUser } from './UserContext';
import { logAction } from './loggingService';

function ManageSpecialties() {
    const { userProfile } = useUser(); // 2. Otteniamo i permessi

    // Usiamo i permessi della pagina 'Stanze' per questa sezione
    const permissionLevel = userProfile?.permissions?.rooms || 'none';
    const canEdit = permissionLevel === 'completo' || permissionLevel === 'semi-completo';
    const canDelete = permissionLevel === 'completo';
    const [specialties, setSpecialties] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingSpecialty, setEditingSpecialty] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchSpecialties = async () => {
    // --- INIZIO MODIFICA ---
    // Controllo di sicurezza per centerId
    if (!userProfile || !userProfile.centerId) {
        setSpecialties([]); // Assicura che la lista sia vuota
        return;
    }
    // Usa il nuovo percorso nidificato
    const querySnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'specialties'));
    // --- FINE MODIFICA ---
    const specialtiesList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setSpecialties(specialtiesList.sort((a, b) => a.name.localeCompare(b.name)));
};

    useEffect(() => {
        fetchSpecialties();
    }, [userProfile]); // <-- MODIFICA QUI

    const handleSaveSpecialty = async (specialtyData) => {
        const dataToSave = {
        name: specialtyData.name,
        color: specialtyData.color, // Aggiungi il colore
    centerId: userProfile.centerId, // <-- AGGIUNGI QUESTA RIGA
};
    if (specialtyData.id) {
        await updateDoc(doc(db, 'centers', userProfile.centerId, 'specialties', specialtyData.id), dataToSave); // <-- MODIFICA QUI
    await logAction(userProfile, `ha modificato la specialistica: ${specialtyData.name}`);
        } else {
            await addDoc(collection(db, 'centers', userProfile.centerId, 'specialties'), dataToSave); // <-- MODIFICA QUI
            // <-- 3. AGGIUNGI LOG
            await logAction(userProfile, `ha creato la specialistica: ${specialtyData.name}`);
        }
        setIsModalOpen(false);
        fetchSpecialties();
    };

    const handleDeleteSpecialty = async (specialtyId) => {
        const specialtyToDelete = specialties.find(s => s.id === specialtyId);
        if (window.confirm("Sei sicuro di voler eliminare questa specialistica?")) {
            await deleteDoc(doc(db, 'centers', userProfile.centerId, 'specialties', specialtyId)); // <-- MODIFICA QUI
            if (specialtyToDelete) {
                await logAction(userProfile, `ha eliminato la specialistica: ${specialtyToDelete.name}`);
            }
            fetchSpecialties();
        }
    };

    const handleEditClick = (specialty) => {
        setEditingSpecialty(specialty);
        setIsModalOpen(true);
    };

    const handleNewClick = () => {
        setEditingSpecialty(null);
        setIsModalOpen(true);
    };
    const filteredSpecialties = specialties.filter(spec =>
        spec.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {isModalOpen && ( <SpecialtyModal specialtyData={editingSpecialty} onSave={handleSaveSpecialty} onClose={() => setIsModalOpen(false)} /> )}
            
            <div className="management-container">
                <div className="management-header">
                    <h4>Specialistiche Esistenti</h4>
                    {canEdit && ( <button onClick={handleNewClick} className="add-new-button">+ Aggiungi Specialistica</button> )}
                </div>

                {/* Barra di ricerca */}
                <div className="filters-container">
                    <input
                        type="text"
                        placeholder="Cerca specialistica per nome..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* Lista filtrata */}
                <div className="management-list">
                    {filteredSpecialties.map(spec => (
                        <div key={spec.id} className="management-card">
                            <div className="card-top-row">
                                <span className="list-item-color-swatch" style={{ backgroundColor: spec.color }}></span>
                                <span className="list-item-main-text">{spec.name}</span>
                            </div>
                            <div className="list-item-actions">
                                {canEdit && <button onClick={() => handleEditClick(spec)} className="info-button">Modifica</button>}
                                {canDelete && <button onClick={() => handleDeleteSpecialty(spec.id)} className="delete-button">Elimina</button>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ManageSpecialties;